/** NOT IN USE  <-------------------------------------------------------------------------------------------------------------------------------------------------> */ 
export const BAGGAGE_BASE_URL = "http://10.20.1.18:3001";
export const secreteKey = "TrVlOsEsEcReTeKeY";
export const HOTEL_BASE_URL = "https://hotelstaging-api.travomint.com"; // staging
export const TRANSFER_BASE_URL = ""; // LIVE OF TRAVOMINT(donot use on live) 
export const scrapping_Host = "http://44.224.252.119:2500/";
export const WEBNAME="B2B"
/** COMMON USE */
export const api_token="0uuZqgE8RXJ2bbkmA1BZSUc02nQzFcsjViLT1ZA9mUwtaokQVZtSqu4UxBAe"
export const CRM_SECRET_KEY = "Hkji0pwekdnihONIOYJGIgjhhjrjkgUGUUYOJU"

// TODO: Before Live
// LIVE BASE_URL 
export const FLIGHT_BASE_URL = "https://wegoroutes.travomint.com/"; // Live do not play with
export const CRM_BASE_URL = "https://crmapi-node.travomint.com/"
export const hostname = "https://partnersapi.travomint.co/"; // Live Url

// STAGING BASE_URL
// export const FLIGHT_BASE_URL = "http://13.127.172.138:5002/";
// export const CRM_BASE_URL = "https://newcrm-api.travomint.com/"
// export const hostname = "http://44.239.80.97:8001/";

// LOCAL BASE URL
// export const FLIGHT_BASE_URL = "http://13.127.172.138:5002/"; 
// export const hostname = "http://10.20.1.56:8001/";
// export const CRM_BASE_URL = "https://newcrm-api.travomint.com/"

// TESTING KEY
export const BLOCK_API_CALL = false // this let oneway api stop and show dummy date for fast response

// NEW CRM API
// export const CRM_BASE_URL = "http://10.20.1.21:3000/"
// Staging : https://newcrm-api.travomint.com/
// Production : https://crmapi-node.travomint.com/

// travomint.com live url donot use for booking  
// export const HOTEL_BASE_URL = "https://hotelapi.travomint.com"; // travomint (do not use on live)
// export const TRANSFER_BASE_URL = "https://transferapi.travomint.com"; // LIVE OF TRAVOMINT(donot use on live)
// export const payuUrl = "https://routes..com/"; // Live Url
// BASE URL Main
// export const payuUrl = "http://13.127.172.138:3001/";
// export const tempHost = "http://10.20.1.38:1001/";